/**
 * prefetchModules — pre-descarga en tiempo ocioso los chunks JS de todos los
 * módulos lazy de la app, una sola vez por sesión de pestaña.
 *
 * Las páginas están code-splitted (lazy() en App.jsx): al navegar a un módulo
 * nunca visitado había que esperar la descarga de su chunk. Llamando esto tras
 * montar el Layout, los chunks quedan en caché del navegador y la navegación
 * pasa a ser instantánea (solo resta el fetch de datos de cada módulo).
 *
 * Los import() usan los MISMOS especificadores que App.jsx, así que Vite
 * resuelve a los mismos chunks — no duplica nada.
 */
const MODULOS = [
  () => import('../pages/DashboardPage'),
  () => import('../pages/BomberosPage'),
  () => import('../pages/GuardiasPage'),
  () => import('../pages/CitacionesPage'),
  () => import('../pages/CircularesPage'),
  () => import('../pages/CuadroListasPage'),
  () => import('../pages/EmergenciasPage'),
  () => import('../pages/ClavesPage'),
  () => import('../pages/CuotasPage'),
  () => import('../pages/OficialesPage'),
  () => import('../pages/MaterialMayorPage'),
  () => import('../pages/OperadoresPage'),
  () => import('../pages/CompaniaServicioPage'),
  () => import('../pages/MaterialMenorPage'),
  () => import('../pages/LicenciasPage'),
  () => import('../pages/EspecialidadesPage'),
  () => import('../pages/EspecialidadDetailPage'),
  () => import('../pages/EstadisticasPage'),
  () => import('../pages/NotificacionesPage'),
  () => import('../pages/TiposBomberoPage'),
  () => import('../pages/MisGuardiasPage'),
  () => import('../pages/MisCuotasPage'),
  () => import('../pages/AdminPage'),
  () => import('../pages/AdminLicenciasPage'),
  () => import('../pages/AdminNotificacionesPage'),
  () => import('../pages/SolicitudesUnionPage'),
]

let iniciado = false

export function prefetchModules() {
  if (iniciado || typeof window === 'undefined') return
  iniciado = true
  const enOcio = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200))
  enOcio(() => {
    // Escalonado (uno cada 250ms) para no competir con los fetch de datos
    // del módulo que el usuario está mirando.
    MODULOS.forEach((cargar, i) => {
      setTimeout(() => {
        cargar().catch(() => {}) // fallo de red aquí es inocuo: se reintenta al navegar
      }, i * 250)
    })
  })
}
